import React from 'react';
import { T } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
var FapiaoRequestFormWrapper = function FapiaoRequestFormWrapper(_ref) {
  var children = _ref.children,
    currency = _ref.currency,
    amount = _ref.amount;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row fapiao-request-form mt-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-8"
  }, /*#__PURE__*/React.createElement("span", {
    className: "float-end mt-1 eligible-amount"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "Amount eligible for Fapiao: **%(amount)s**",
    params: {
      amount: price(currency, amount)
    }
  })), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "Fapiao details"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row fapiao-request-form mt-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6"
  }, children)));
};
export default FapiaoRequestFormWrapper;